import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { AiOutlineClose } from "react-icons/ai";
import { FaRegEye } from "react-icons/fa";
import {
  Wrapper,
  Card,
  ImgContainer,
  DetailsContainer,
  Header,
  Position,
  DismisContainer,
  Info,
} from "./experience-details.styles";
import data from "../../utils/data/companies.json";
import { topDownAni } from "../../utils/motion/motion.utils";
import { useAppContext } from "../../layout/layout";
import { FormattedMessage } from "react-intl";

const ExperienceDetailsPopUp = ({ id, setId }) => {
  const [company, setCompany] = useState({});
  const { lang } = useAppContext();

  useEffect(() => {
    const comp = data.companies.find((company) => company.id === id);
    setCompany(comp);
  }, [id]);

  return (
    <Wrapper>
      <motion.div {...topDownAni} className="card-container">
        <Card>
          <ImgContainer>
            <img src="./assets/images/developer.png" alt="shows 3d developer" />
          </ImgContainer>
          <DetailsContainer>
            <DismisContainer>
              <AiOutlineClose
                onClick={() => setId(null)}
                className="dismis-icon"
              />
              <a href={company.certificate} target="_blank" rel="noreferrer">
                <FaRegEye className="view-icon" />
              </a>
            </DismisContainer>
            <Header>
              <Position>
                <h4>{lang === "en" ? company.en_name : company.de_name}</h4>
                <p>__</p>{" "}
                <h5>{lang === "en" ? company.en_role : company.de_role}</h5>
                <a href={company.certificate} target="_blank" rel="noreferrer">
                  <FaRegEye className="view-icon" />
                </a>
              </Position>
              <p>{lang === "en" ? company.en_info : company.de_info}</p>
            </Header>
            <Info>
              <p>{lang === "en" ? company.en_desc : company.de_desc}</p>
              <h5>
                <FormattedMessage
                  id="experienced"
                  defaultMessage="Experienced"
                />
              </h5>
              <p>{company.experience}</p>
              <h5>
                <FormattedMessage id="tools" defaultMessage="Tools" />
              </h5>
              <p>{company.tools}</p>
            </Info>
          </DetailsContainer>
        </Card>
      </motion.div>
    </Wrapper>
  );
};
export default ExperienceDetailsPopUp;
